query currentTeacherPhoneNumber($teamId: ID!) {
  currentTeacherPhoneNumber(teamId: $teamId) {
    id
    formattedNumber
  }
}
